import React, { useEffect, lazy, Suspense, useState } from "react";
import { motion } from "framer-motion";
import { useGLTF } from "@react-three/drei";
import ThreeViewer from "../../Components/Home/ThreeViewer";
import dtshirt from "../../images/3dtshirt.glb";
import ImagesCv from "../../Components/Home/ImagesCv";
import { ExpandableCardDemo } from "../../Components/Home/ExpandableCardDemo";
import { WobbleCardDemo } from "../../Components/Home/WobbleCardDemo";
import { SquigglyText } from "../../Components/UI/squiggly-text";
import { AccordionDemo } from "../../Components/Home/LastComp/AccardionDemo";
import LastComp from "../../Components/Home/LastComp/LastComp";
import Footerls from "../../Components/footer/Footerls";
import Hero from "../../Components/UI/animated-hero";
import { useNavigate } from "react-router-dom";
import { routes } from "../../Constants/Routes";
import mainimg from "../../images/main.png";
// const ThreeViewer = lazy(() => import("./ThreeViewer"));
const images = [
  "https://odditeesprinting.com/wp-content/uploads/2026/01/image-gen-9-scaled.png",
  "https://odditeesprinting.com/wp-content/uploads/2026/01/image-gen-9-scaled.png",
  "https://odditeesprinting.com/wp-content/uploads/2026/01/image-gen-9-scaled.png",
  "https://odditeesprinting.com/wp-content/uploads/2026/01/image-gen-9-scaled.png",
];
const LazyThreeViewer = React.lazy(
  () =>
    new Promise((resolve) =>
      setTimeout(
        () => resolve(import("../../Components/Home/ThreeViewer")),
        9000,
      ),
    ),
);
const Home = () => {
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  return (
    <div className="flex flex-col gap-32 md:gap-56">
      <div className="relative flex h-[800px] clg:h-[900px] max-h-screen w-full items-center justify-center overflow-hidden shadow-2xl">
        <div className="absolute inset-0 flex items-center justify-center">
          {!loaded && (
            <div className="absolute inset-0 animate-pulse bg-neutral-800" />
          )}
          <img
            src={mainimg}
            alt="main"
            onLoad={() => setLoaded(true)}
            className={`h-full w-full object-cover transition-opacity duration-700 ${
              loaded ? "opacity-100" : "opacity-0"
            }`}
          />
        </div>

        <div className="relative z-10 mx-auto flex max-w-4xl flex-col items-center gap-4 px-4 text-center">
          <div className="flex h-[40rem] w-[350px] ssxx:w-[405px] ssm:w-[475px] sfm:w-[1500px] flex-col items-center justify-center gap-8 px-4 text-center sm:gap-10">
            <h1 className="w-full text-3xl font-bold leading-tight text-neutral-100 ssxx:text-4xl sm:text-5xl mmd:text-6xl cxl:text-7xl">
              პრემიუმ ხარისხის ბეჭდვა
              <br />
              და ბრენდინგი
            </h1>

            <h2 className="w-[300px] sfm:w-[400px] lg:w-[560px] text-sm font-semibold leading-7 text-white font-ArialGeo ssxx:text-base sm:text-lg mmd:text-xl cxl:text-2xl">
              მაღალი ხარისხის DTF ბეჭდვა ინდივიდუალური და კორპორატიული
              შეკვეთებისთვის.
            </h2>

            <button
              onClick={() => navigate(routes.GetOrder)}
              className="
            relative border-none bg-transparent cursor-pointer transition-all
            duration-300 pb-[10px] pl-[2px] mr-[10px]
            text-[18px] sfm:text-[20px] mmd:text-[24px]
            uppercase tracking-[4px] text-white active:scale-90

            before:content-['⇝']
            before:absolute
            before:text-[48px]
            before:top-[-26px]
            sfm:before:top-[-24px]
            mmd:before:top-[-22px]
            before:right-[-10px]
            before:translate-x-full

            after:content-['']
            after:absolute
            after:left-0
            after:bottom-0
            after:h-[2px]
            after:w-full
            after:bg-white
            after:origin-bottom-right
            after:scale-x-0
            after:transition-transform
            after:duration-300

            hover:after:scale-x-100
            hover:after:origin-bottom-left
          "
            >
              შეუკვეთე
            </button>
          </div>
        </div>
      </div>
      <div className="relative mx-auto flex w-full max-w-9xl flex-col items-center justify-center gap-5 px-2 py-5 sfm:px-4 lg:flex-row lg:px-1 xl:gap-4 xl:px-5 clg:px-14 cxl:gap-10 cxl:px-4">
        <div className="aspect-square w-full max-w-[600px] p-4 lg:flex-1 lg:p-2 xl:p-4">
          <div className="relative right-6 flex h-full cursor-pointer flex-col bg-cover bg-center bg-no-repeat ssmm:right-8 sfm:right-10 lg:right-0">
            <div className="h-full w-full">
              <Suspense
                fallback={
                  <div className="w-full h-full flex items-center justify-center">
                    <div className="loader25">
                      <span>Loading...</span>
                    </div>
                  </div>
                  // <div className="w-full h-full flex items-center justify-center">
                  //   <div className="loader"></div>
                  // </div>
                }
              >
                <ThreeViewer />
              </Suspense>
            </div>
          </div>
        </div>

        <div className="w-full max-w-3xl p-0 pt-0 sfm:p-2 lg:flex-1 cxl:max-w-4xl cxl:p-5">
          <h1 className="font-Mtavruli text-3xl text-black xsxm:text-4xl cxl:text-5xl">
            ჩვენს შესახებ
          </h1>

          <p className="mt-3 pl-1 text-sm font-semibold text-black font-ArialGeo ssxx:text-md ssm:mt-5 ssm:text-lg smm:text-xl lg:text-lg cxl:text-xl">
            ჩვენ ბაზარზე 2023 წლიდან ვმოღვაწეობთ და ამ დროის განმავლობაში უკვე
            მოვიპოვეთ სანდო სახელი — ცნობილი ვართ სტაბილური შედეგებით, ეფექტური
            წარმოებითა და უმაღლესი ხარისხის პროდუქციით.
          </p>

          <p className="mt-2 pl-1 text-sm font-semibold text-black font-ArialGeo ssxx:text-md ssm:mt-5 ssm:text-lg smm:text-xl lg:text-lg cxl:text-xl">
            ჩვენი მთავარი მიზანია თითოეულ მომხმარებელზე ინდივიდუალური ზრუნვა და
            მათთან გრძელვადიანი პარტნიორული ურთიერთობების ჩამოყალიბება. ჩვენ
            ვაანალიზებთ თითოეული კლიენტის საჭიროებებს და ვთავაზობთ მათზე
            მორგებულ გადაწყვეტილებებს.
          </p>

          <p className="mt-2 pl-1 text-sm font-semibold text-black font-ArialGeo ssxx:text-md ssm:mt-5 ssm:text-lg smm:text-xl lg:text-lg cxl:text-xl">
            სწორედ ამ მიდგომამ მოგვცა შესაძლებლობა, რომ მუდმივად განვვითარდეთ და
            მოვერგოთ როგორც ადგილობრივი, ისე საერთაშორისო ბაზრის მოთხოვნებს.
          </p>
        </div>
      </div>

      <ExpandableCardDemo />

      <WobbleCardDemo />

      <LastComp />

      <Hero />

      <Footerls />
    </div>
  );
};

export default Home;
